const CF7_UTM_TRACKING_PREFIX = 'cf7_';
const CF7_UTM_TRACKING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'gclid'
];

class CF7UTMTrackingManager {
    constructor() {
        this.expirationDays = 30;
        this.urlParams = new URLSearchParams(window.location.search);
        this.utmParams = CF7UTMTrackingManager.getUTMParams();

        if (this.urlHasUTMParams()) {
            this.storeUTMParams();
        }
    }

    urlHasUTMParams() {
        return CF7_UTM_TRACKING_KEYS.some(key => this.urlParams.has(key));
    }

    storeUTMParams() {
        const now = new Date();
        const expirationDate = new Date(now.getTime() + this.expirationDays * 24 * 60 * 60 * 1000);

        CF7_UTM_TRACKING_KEYS.forEach(key => {
            const value = this.urlParams.get(key);
            if (value) {
                const storageKey = CF7_UTM_TRACKING_PREFIX + key;
                const data = {
                    value: this.santinizeValue(value),
                    expires: expirationDate.getTime()
                };
                localStorage.setItem(storageKey, JSON.stringify(data));
            }
        });
    }

    santinizeValue(value) {
        return value.replace(/[^a-zA-Z0-9-_]/g, '');
    }

    static getUTMParams() {
        const params = {};
        const now = new Date().getTime();

        CF7_UTM_TRACKING_KEYS.forEach(key => {
            const storageKey = CF7_UTM_TRACKING_PREFIX + key;
            const item = localStorage.getItem(storageKey);

            if (item) {
                const data = JSON.parse(item);
                if (data.expires > now) {
                    params[key] = data.value;
                } else {
                    localStorage.removeItem(storageKey);
                }
            }
        });

        return params;
    }
}

class CF7UTMTrackingForm {
    constructor(formElement) {
        this.formElement = formElement;
        this.fields = [];

        this.init();
    }

    init() {
        this.setHiddenFields();
    }

    setHiddenFields() {
        const utmParams = CF7UTMTrackingManager.getUTMParams();

        CF7_UTM_TRACKING_KEYS.forEach(key => {
            const fieldName = key;
            const field = this.formElement.querySelector(`input[name="${fieldName}"]`);
            const value = utmParams[key] || '';

            if (field && value) {
                this.fields.push(field);

                field.value = value;
            }
        });
    }
}

class CF7UTMTracking {
    constructor(formSelectors = []) {
        this.manager = new CF7UTMTrackingManager();
        this.formSelectors = formSelectors.length ? formSelectors : ['form.wpcf7-form'];
        this.forms = new Set();

        this.init();
    }

    init() {
        if (!this.formSelectors.length) return;

        this.formSelectors.forEach(selector => {
            const forms = document.querySelectorAll(selector);

            if (!forms.length) return;

            forms.forEach((formElement) => {
                const form = new CF7UTMTrackingForm(formElement);

                this.forms.add(form);
            });
        });
    }
}

export default CF7UTMTracking;